export default "__VITE_ASSET__kFPrcKYx__";